
import './App.css';
import image from './images/image-product-desktop.jpg'
import icon from './images/icon-cart.svg';

function Card() {
  return (
    <div className="Card ">
      {/* Body Container */}
      <div className='flex  h-[100vh]   bg-[#F3EAE3] items-center  justify-center  '>
        {/* Card Container */}
        <div className='flex flex-nowrap flex-col md:flex-wrap md:flex-row md:w-[600px] md:h-[420px] content-center  w-[300px] h-[620px] '>
          {/* Image container */}
          <div className=' flex w-[300px] h-[240px] md:h-auto'>
            <img id='' className='image-container ' src={image} alt="" />
          </div>
          {/* Text container */}
          <div className='text-container p-3 md:p-6  flex  flex-col  bg-white  w-[300px] h-[380px] md:h-[auto]'>
            <span className='text-[#b7b6b6] font-light tracking-[5px] pb-2 md:p-3 md:text-[15px] text-[13px]'>PERFUME</span>
            <h1 className='font-bold md:text-[28px]  text-[25px] tracking-[1px] pb-3'>Gabrielle 
            <br /> Essence Eau <br /> De Parfum</h1>
            <p className='text-[#b7b6b6] text-[14px] pb-3 md:text-[16px]'>A floral, solar and voluptuous interpretation composed by Olivier Polge, Perfumer-Creator for the House of CHANEL.</p>
            <div className='flex space-x-9 pb-4 '>
            <h3 className='price text-[23px] md:text-[23px]  '>$149.99</h3>
            <span className='line-through text-gray-300 pt-1.5'>$169.99</span>
            </div>
            <button className='flex bg-[#3F816B] h-[40px]  items-center  justify-center rounded-[10px] hover:bg-[#7eb8a5] hover:text-[#519981]'><img className='p-1 ' src={icon} alt="" />Add to Cart</button>
        </div>
        </div>
      </div>
    </div>
  );
}

export default Card;


